module.exports = __webpack_public_path__ + "static/media/0018.1466f73d.jpg";